import { inject } from '@angular/core';
import { BranchesApi, BranchListItem } from '@idealsupply/ngclient-webservice-branches';
import { signalStore } from '@ngrx/signals';
import { map } from 'rxjs';
import { withCachedEntityCollectionStore } from 'state-data';

export const PickupStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityCollectionStore({
    selectId: (p: BranchListItem) => p.branch!,
    loadAll: () => {
      return inject(BranchesApi)
        .pickupGet()
        .pipe(
          map((data) => {
            return data;
          }),
        );
    },
    cacheSeconds: 60,
  }),
);
